(() => {
  try {
    const ua = navigator.userAgent || navigator.vendor || window.opera || "";
    const platform = navigator.platform || "";

    // iPad detection covers iPadOS 13+ which reports as Macintosh but supports touch
    const isIpad = /iPad/.test(ua) || (platform === "MacIntel" && typeof navigator.maxTouchPoints === "number" && navigator.maxTouchPoints > 1);

    const isIphone = /iPhone/.test(ua) && !isIpad;
    const isIpod = /iPod/.test(ua);
    const isIOS = isIpad || isIphone || isIpod;
    const isAndroid = /Android/.test(ua);
    const hasTouch = "ontouchstart" in window || (navigator.maxTouchPoints || 0) > 0;

    const html = document.documentElement;
    html.classList.toggle("has-touch", !!hasTouch);
    html.classList.toggle("is-ios", !!isIOS);
    html.classList.toggle("is-ipad", !!isIpad);
    html.classList.toggle("is-android", !!isAndroid);

    window.Device = Object.freeze({
      ua,
      platform,
      isIOS,
      isIpad,
      isIphone,
      isAndroid,
      hasTouch,
    });
  } catch (e) {
    // fail silently
  }
})();
